import { render, staticRenderFns } from "./UndergraduateTransferList.vue?vue&type=template&id=7238ff09"
import script from "./UndergraduateTransferList.vue?vue&type=script&lang=js"
export * from "./UndergraduateTransferList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports